var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E8F0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12293_33284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8 8C10.175 8 9.2 8.86719 9.2 11.2V24.4C9.2 24.9438 9.35938 25.3359 9.6 25.625V26.8C9.6 27.4609 10.1391 28 10.8 28H12.4C13.0609 28 13.6 27.4609 13.6 26.8V26.4H22.4V26.8C22.4 27.4609 22.9391 28 23.6 28H25.2C25.8609 28 26.4 27.4609 26.4 26.8V25.625C26.6406 25.3359 26.8 24.9438 26.8 24.4V11.6C26.8 9.85781 26.5844 8 24 8H12.8ZM14 9.6H22.4C22.6219 9.6 22.8 9.77969 22.8 10V10.8C22.8 11.0203 22.6219 11.2 22.4 11.2H14C13.7797 11.2 13.6 11.0203 13.6 10.8V10C13.6 9.77969 13.7797 9.6 14 9.6ZM12.4 12.4H23.6C24.4 12.4 24.8 12.8 24.8 13.6V18.4C24.8 19.2 24.0188 19.575 23.6 19.575L12.4 19.6C11.6 19.6 11.2 19.2 11.2 18.4V13.6C11.2 12.8 11.6 12.4 12.4 12.4ZM8.8 12.8C8.35938 12.8 8 13.1594 8 13.6V16.8C8 17.2406 8.35938 17.6 8.8 17.6V12.8ZM27.2 12.8V17.6C27.6422 17.6 28 17.2406 28 16.8V13.6C28 13.1594 27.6422 12.8 27.2 12.8ZM12.6 21.6C13.3734 21.6 14 22.2266 14 23C14 23.7734 13.3734 24.4 12.6 24.4C11.8266 24.4 11.2 23.7734 11.2 23C11.2 22.2266 11.8266 21.6 12.6 21.6ZM23.4 21.6C24.1734 21.6 24.8 22.2266 24.8 23C24.8 23.7734 24.1734 24.4 23.4 24.4C22.6266 24.4 22 23.7734 22 23C22 22.2266 22.6266 21.6 23.4 21.6Z",
    fill: "#3077F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12293_33284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehIcon);
export default __webpack_public_path__ + "static/media/veh_icon.baa34561c2044370bd4a82f79238b7c0.svg";
export { ForwardRef as ReactComponent };